//
//
//
//
//
//
//
import UserView01 from "@/components/statistical/user/UserView01";
import ForLink from "@/components/statistical/ForLink";
export default {
  name: "User",
  components: {
    UserView01: UserView01,
    ForLink: ForLink
  },
  props: [],
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};